<template>
    <Dialog v-model:visible="visible" modal :header="$t('guest_form.title')" :style="{ width: '25rem' }">
        <span class="text-surface-500 dark:text-surface-400 block mb-4">{{ $t('guest_form.subtitle') }}</span>

        <div v-if="error_message" class="p-error mb-4">
            {{ error_message }}
        </div>
        <div class="flex  gap-1 mb-4">
            <label for="username" class="font-semibold w-24">{{ $t('guest_form.new_username') }}</label>
            <InputText id="username" v-model="formData.username" class="flex-auto" autocomplete="off" required="true"/>
        </div>
        <div class="flex  gap-1 mb-4">
            <label for="email" class="font-semibold w-24">{{ $t('guest_form.new_email') }}</label>
            <InputText id="email" v-model="formData.email" class="flex-auto" autocomplete="off" required="true" />
        </div>
        <div class="flex  gap-1 mb-4">
            <label for="pass" class="font-semibold w-24">{{ $t('guest_form.password') }}</label>
            <Password id="pass" v-model="formData.password" class="flex-auto" autocomplete="off" required="true" toggleMask fluid/>
        </div>
        <div class="flex  gap-1 mb-4">
            <label for="r_pass" class="font-semibold w-24">{{ $t('guest_form.password_confirmation') }}</label>
            <Password id="r_pass" v-model="formData.password_confirmation" class="flex-auto" autocomplete="off" required="true" toggleMask fluid/>
        </div>
        <div class="flex justify-end gap-2">
            <Button type="button" :label="$t('guest_form.register')" 
                @click="completeRegister" :disabled="isPosted"></Button>
            <Button type="button" :label="$t('dialogs.private_channel_cancel')"  severity="secondary" @click="visible = false"></Button>
        </div>
    </Dialog>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            isPosted: false,
            error_message: '',
            formData:
            {
                username: '',
                email: '',
                password: '',
                password_confirmation: ''
            }
        };
    },
    methods: {
        showDialog() {
            this.visible = true;
        },
        completeRegister() {

            if (this.formData.password !== this.formData.password_confirmation) {
                this.error_message = this.$t('guest_form.password_mismatch');
                return;
            }

            if (this.formData.password.length < 5) {
                this.error_message = this.$t('guest_form.password_length');
                return;
            }

            if (this.formData.username.length < 3) {
                this.error_message = this.$t('guest_form.username_length');
                return;
            }
            if (this.checkValidEmail(this.formData.email) === false) {
                this.error_message = this.$t('guest_form.email_invalid');
                return;
            }

            this.isPosted = true;

            this.$socket.emit('completeRegister', this.formData);
        },
        checkValidEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    },

    mounted() {
        this.$socket.on('registerCompleted', (data) => {
           if (data.success) {
               window.location.reload();
           }


           if (data.error) {
                const err_msg = 'guest_form.' + data.error;
               this.error_message = this.$t(err_msg);
               this.isPosted = false;
           }
        });
    },
    unmounted() {
        this.$socket.off('registerCompleted');
    }
};  
</script>

<style scoped>
.flex {
    display: flex;
    flex-direction: column;
}

</style>